import { TenantIntegrationType } from './tenantIntegrationType';

export class TenantIntegration {
  public integrationType: TenantIntegrationType;

  constructor(integrationType: TenantIntegrationType) {
    this.integrationType = integrationType;
  }

  get providesCertifications(): boolean {
    return this.integrationType === TenantIntegrationType.CertMetrics;
  }

  static parse(obj: any): TenantIntegration {
    if (!obj) return;

    return new TenantIntegration(
      TenantIntegrationType[obj.integrationType] as TenantIntegrationType
    );
  }
}
